import { UserOutlined } from '@ant-design/icons';
import type { NavigationItemType } from '~/types/navigation';

export default {
    id: 'users',
    permission: 'user.list',
    title: 'Korisnici',
    icon: UserOutlined,
    type: 'item',
    url: '/users',
} satisfies NavigationItemType;
